import * as React from 'react';
import { signInGoogle, signInMicrosoft } from './auth';
import { BrandLockup, GoogleMark, Icon, MicrosoftMark, SeltzerArt } from './brand';
import { Link } from './Shell';

// /signin - choose Microsoft 365 or Google Workspace.

const SignIn: React.FunctionComponent<{ googleClientId: string | null; error?: string; returnTo: string }> = ({ googleClientId, error, returnTo }) => (
  <div className="bu-signin">
    <aside className="bu-signin-art">
      <Link to="/" className="bu-brand" style={{ color: '#fff' }}><BrandLockup size={34} /></Link>
      <div>
        <div style={{ marginBottom: 36 }}><SeltzerArt height={150} /></div>
        <blockquote>
          The right tools for your team, with your company's data kept private to your company.
          <small>BeefedUp IT</small>
        </blockquote>
      </div>
      <div style={{ display: 'flex', gap: 22, color: 'var(--graphite-400)', fontSize: 13, fontWeight: 600 }}>
        <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}><Icon name="lock" size={16} /> Encrypted</span>
        <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}><Icon name="database" size={16} /> Isolated per organization</span>
      </div>
    </aside>
    <main className="bu-signin-form">
      <div className="bu-signin-box">
        <h1>Sign in</h1>
        <p>Use your work account. Your organization decides which apps you can open.</p>
        {error !== undefined && error !== '' && <div className="bu-alert bu-alert-danger" style={{ marginBottom: 18 }}>{error}</div>}
        <button className="bu-idp" onClick={(): void => signInMicrosoft(returnTo)}>
          <MicrosoftMark size={22} /><span>Continue with Microsoft</span><em>Microsoft 365</em>
        </button>
        {googleClientId !== null ? (
          <button className="bu-idp" onClick={(): void => { void signInGoogle(googleClientId, returnTo); }}>
            <GoogleMark size={22} /><span>Continue with Google</span><em>Workspace</em>
          </button>
        ) : (
          <button className="bu-idp" disabled={true} style={{ opacity: .5, cursor: 'default' }} title="Google sign-in is being set up">
            <GoogleMark size={22} /><span>Continue with Google</span><em>Coming soon</em>
          </button>
        )}
        <p className="bu-signin-legal">
          Personal Microsoft and Gmail accounts aren't supported. By signing in you agree to the <a href="/terms">Terms</a> and <a href="/privacy">Privacy Policy</a>.
          Not a BeefedUp IT client yet? <a href="https://beefedupit.com">Talk to us</a>.
        </p>
      </div>
    </main>
  </div>
);

export default SignIn;
